//@ts-check
import {
  BarChart3,
  Clapperboard,
  HardDrive,
  LayoutDashboard,
  Settings2,
  Shield,
  Store,
  Trash2,
  Users,
  Video,
} from 'lucide-react';

import { hasPermission, isAdmin } from './permissions.js';

/**
 * @typedef {object} NavItem
 * @property {string} label
 * @property {string} [to]
 * @property {import('lucide-react').LucideIcon} [icon]
 * @property {NavItem[]} [children]
 * @property {(user: import('./permissions.js').AuthUser) => boolean} visible
 */

/** @type {NavItem[]} */
export const NAV_ITEMS = [
  {
    label: 'Dashboard',
    to: '/',
    icon: LayoutDashboard,
    visible: (user) => isAdmin(user),
  },
  {
    label: 'Record',
    to: '/record',
    icon: Clapperboard,
    visible: (user) => hasPermission(user, 'record'),
  },
  {
    label: 'Videos',
    to: '/videos',
    icon: Video,
    visible: (user) => hasPermission(user, 'view'),
  },
  {
    label: 'Reports',
    to: '/reports',
    icon: BarChart3,
    visible: (user) => isAdmin(user),
  },
  {
    label: 'Marketplaces',
    to: '/marketplaces',
    icon: Store,
    visible: (user) => isAdmin(user),
  },
  {
    label: 'Users',
    to: '/users',
    icon: Users,
    visible: (user) => isAdmin(user),
  },
  {
    label: 'Settings',
    icon: Settings2,
    visible: (user) => isAdmin(user),
    children: [
      { label: 'Storage', to: '/admin/storage', icon: HardDrive, visible: (user) => isAdmin(user) },
      {
        label: 'Data Retention',
        to: '/admin/data-retention',
        icon: Trash2,
        visible: (user) => isAdmin(user),
      },
      {
        label: 'Site Settings',
        to: '/admin/site-settings',
        icon: Shield,
        visible: (user) => isAdmin(user),
      },
    ],
  },
];

/**
 * @param {import('./permissions.js').AuthUser} user
 * @returns {NavItem[]}
 */
export function getVisibleNav(user) {
  return NAV_ITEMS.filter((item) => item.visible(user)).map((item) => {
    if (!item.children) return item;
    return {
      ...item,
      children: item.children.filter((child) => child.visible(user)),
    };
  });
}

/**
 * Default landing path for a user.
 * @param {import('./permissions.js').AuthUser} user
 * @returns {string}
 */
export function defaultHomePath(user) {
  if (isAdmin(user)) return '/';
  if (hasPermission(user, 'record')) return '/record';
  if (hasPermission(user, 'view')) return '/videos';
  return '/login';
}
